import { render, staticRenderFns } from "./GestionVenta.vue?vue&type=template&id=a549a798&"
import script from "./GestionVenta.vue?vue&type=script&lang=js&"
export * from "./GestionVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports